import { MapWrapper } from "../styles/jss/ContactUs.styles";
import { useEffect } from "react";

export default function Map() {
  // useEffect(() => {
  //   handleAttachGoogleMap();
  // }, []);
  //
  // const handleAttachGoogleMap = () => {
  //   const geocoder = new google.maps.Geocoder();
  //   const LatLng = new google.maps.LatLng(27.542325, 52.554539);
  //   const mapOptions = {
  //     center: LatLng,
  //     mapTypeControl: false,
  //     streetViewControl: false,
  //     zoom: 14,
  //     style: [
  //       {
  //         featureType: "landscape",
  //         stylers: [
  //           {
  //             hue: "#F1FF00",
  //           },
  //           {
  //             saturation: -27.4,
  //           },
  //           {
  //             lightness: 9.4,
  //           },
  //           {
  //             gamma: 1,
  //           },
  //         ],
  //       },
  //       {
  //         featureType: "road.highway",
  //         stylers: [
  //           {
  //             hue: "#0099FF",
  //           },
  //           {
  //             saturation: -20,
  //           },
  //           {
  //             lightness: 36.4,
  //           },
  //           {
  //             gamma: 1,
  //           },
  //         ],
  //       },
  //       {
  //         featureType: "road.arterial",
  //         stylers: [
  //           {
  //             hue: "#00FF4F",
  //           },
  //           {
  //             saturation: 0,
  //           },
  //           {
  //             lightness: 0,
  //           },
  //           {
  //             gamma: 1,
  //           },
  //         ],
  //       },
  //       {
  //         featureType: "road.local",
  //         stylers: [
  //           {
  //             hue: "#FFB300",
  //           },
  //           {
  //             saturation: -38,
  //           },
  //           {
  //             lightness: 11.2,
  //           },
  //           {
  //             gamma: 1,
  //           },
  //         ],
  //       },
  //       {
  //         featureType: "water",
  //         stylers: [
  //           {
  //             hue: "#00B6FF",
  //           },
  //           {
  //             saturation: 4.2,
  //           },
  //           {
  //             lightness: -63.4,
  //           },
  //           {
  //             gamma: 1,
  //           },
  //         ],
  //       },
  //       {
  //         featureType: "poi",
  //         stylers: [
  //           {
  //             hue: "#9FFF00",
  //           },
  //           {
  //             saturation: 0,
  //           },
  //           {
  //             lightness: 0,
  //           },
  //           {
  //             gamma: 1,
  //           },
  //         ],
  //       },
  //     ],
  //   };
  //   const map = new google.maps.Map(
  //     document.getElementById("google-map"),
  //     mapOptions,
  //   );
  //
  //   // setTimeout(() => {
  //   //   const marker = new google.maps.Marker({
  //   //     position: {
  //   //       lat: 27.542325,
  //   //       lng: 52.554539,
  //   //     },
  //   //     map: map,
  //   //     // icon:"",
  //   //     // animation:google.maps.Animation.BOUNCE,
  //   //   });
  //   // }, 2000);
  // };

  return (
    <MapWrapper>
      {/*<div id="google-map" />*/}
      <iframe
        src="https://www.google.com/maps?ll=27.542325,52.554539&z=14&t=m&hl=en-US&gl=US&mapclient=embed&cid=15522380775205809026&output=embed"
        frameBorder="0"
        aria-hidden="false"
        tabIndex="0"
        loading="lazy"
        allowFullScreen={true}
      />
    </MapWrapper>
  );
}

// import { MapWrapper } from "../styles/jss/ContactUs.styles";
// import { GoogleMap, LoadScript } from "@react-google-maps/api";
// export default function Map() {
//   const mapStyles = {
//     height: "400px",
//     width: "100%",
//   };
//
//   const center = {
//     lat: 27.542325,
//     lng: 52.554539,
//   };
//
//   return (
//     <MapWrapper>
//       <LoadScript
//         googleMapsApiKey={"AIzaSyDpiCS84-BfU2bPzoUZtxMTnU4HWe9reS4"}
//         id={"15522380775205809026"}
//       >
//         <GoogleMap mapContainerStyle={mapStyles} center={center} zoom={15} />
//       </LoadScript>
//     </MapWrapper>
//   );
// }
